import { render, staticRenderFns } from "./distributorList.vue?vue&type=template&id=f6ae2fe0"
import script from "./distributorList.vue?vue&type=script&lang=js"
export * from "./distributorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports